export default __webpack_public_path__ + "static/media/chassis-plate.ab982d80.png";